
import React from 'react'
import { Helmet } from 'react-helmet'
import { Link } from 'react-router-dom'
import { skypeImg1, teamsImg3, whatsupImg2 } from '../../assets/img'
import Footer from '../../components/Footer/Footer'
import Header from '../../components/Header/Header'
import MeetTheTeam from '../../components/MeetTheTeam/MeetTheTeam'
import './ContactPage.css'

function ContactPage() {
 
  return (
    < >
      <Helmet>
        <meta charSet="utf-8" />
        <title>Contact | TechFreelanceX</title>
        <meta name="description" content="TechFreelanceX is group of independent professionals who will to  work on technology projects on a freelance basis." />
      </Helmet>
      <Header />
      <section className='hero'>
        <div className="hero-inner container">
          <div className="line_1">
            <h2>
              <Link to='mailto:techfreelanceX@gmail.com'>Techfreelance<span className='cambon_font'>X</span>@gmail.com</Link>
            </h2>
          </div>
          <div className="line_2">
            <h2 className='cambon_font'><Link to='tel:9758635932'>+91 9758635932</Link></h2>
          </div>
        </div>
      </section>
      <section className='connnect-wrap spacing' >
        <div className="container">
          <h4>Also connect on </h4>
          <div className="c_slider">
              <Link  to="https://wa.me/qr/74WWA3D3NLWYJ1" target="_blank" className="c_items ">
                <div className="c_item_inner ">
                  <div className="icon">
                    <img src={whatsupImg2} alt="Whatsup" />
                    <h6>Whatsapp</h6>
                  </div>

                </div>
              </Link>
              <Link to="https://join.skype.com/invite/uCrj4Mebu3gh" target="_blank" className="c_items ">
                <div className="c_item_inner ">
                  <div className="icon">
                    <img src={skypeImg1} alt="Skype" />
                    <h6>Skype</h6>
                  </div>

                </div>
              </Link>
              <Link  to="https://teams.live.com/l/invite/FEAgo0pa_5lz7qpfAE" target="_blank" className="c_items ">
                <div className="c_item_inner ">
                  <div className="icon">
                    <img src={teamsImg3} alt="Microsoft Teams" />
                    <h6>MS Teams</h6>
                    <h6><small><em>(Recommended)</em></small></h6>
                  </div>

                </div>
              </Link>
           

          </div>
          </div>
       
      </section>
      <MeetTheTeam />
      <Footer />
    </>
  )
}

export default ContactPage